export const STUDENT_CATEGORY = [
   {label: 'General', value: 'general'},
   {label: 'SC', value: 'sc'},
   {label: 'St', value: 'st'},
   {label: 'OBC', value: 'obc'},
   {label: 'Others', value: 'others'},
];

